import ClassNames from 'classnames';
import React from 'react';
import { getLanguage } from '../../../helpers/functions/language';
import {
  PaginationControlBase
} from './../../base';
import { PaginationControlWrapper } from './styled';

export class PaginationControl extends React.PureComponent {
  render() {
    const {
      children,
      className
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
      'is-default'
    )

    return (
      <PaginationControlWrapper
        {...this.props}
        className={classes}
      >
        {children}
      </PaginationControlWrapper>
    )
  }

  static defaultProps = {
    hideFirstLastPages: true,
    // prevPageText: getLanguage('pagination.previous', ''),
    // nextPageText: getLanguage('pagination.next', '')
    prevPageText: "Previous",
    nextPageText: "Next",
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
